export default "__VITE_ASSET__DzEPnm5u__"